import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import Header, { HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE } from './Header';
import Footer from '../components/Footer';
import { WILD_SAND, BASE_SPACING, MEDIA_QUERIES } from '../styles';

const s = StyleSheet.create({
  root: {
    backgroundColor: WILD_SAND,
    minHeight: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: `calc(100vh - 50px - ${HEADER_HEIGHT_MOBILE}px)`,
    paddingBottom: BASE_SPACING,
    [MEDIA_QUERIES.ON_DESKTOP]: {
      minHeight: `calc(100vh - 50px - ${HEADER_HEIGHT_DESKTOP}px)`,
    },
  },
});

const Layout = ({ children, title }) => (
  <div className={css(s.root)}>
    <Header title={title} />
    <div className={css(s.content)}>{children}</div>
    <Footer />
  </div>
);

Layout.propTypes = {
  children: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default Layout;
